import { FACILITY_DISPATCH_TARGET_MASTER_FACILITY } from "redux/facilityDispatchMeta";
import { IFacility } from "../models/facility";

export interface IMasterFacilityState {
  isLoaded: boolean;
  error?: any;
  facility?: IFacility;
  facilities?: Array<IFacility>;
  weather?: any;
}

export interface IFacilityAction {
  type: string;
  payload: Partial<IMasterFacilityState>;
  meta?: { facilityDispatchTarget?: typeof FACILITY_DISPATCH_TARGET_MASTER_FACILITY };
}

const initialState: IMasterFacilityState = {
  isLoaded: false,
  error: null,
  facility: null,
  facilities: [],
  weather: null,
};

export default function MasterFacilityReducer(state = initialState, action: IFacilityAction) {
  switch (action.type) {
    case "facility.update":
      if (action.meta?.facilityDispatchTarget !== FACILITY_DISPATCH_TARGET_MASTER_FACILITY) {
        return state;
      }
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
